export const MODES_REQUIRING_ELEMENT = ['dailyDungeon', 'guildBoss'];
